import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuoteRevisionService } from '../../services/quote-revision.service';
import { QuoteRevisionInfoService } from './../../services/quote-revision-info.service';

@Component({
  selector: 'revert-revision-aside',
  template: require('./revert-revision-aside.component.html'),
  styles: [require('./revert-revision-aside.component.scss')]
})
export class RevertRevisionAsideComponent implements OnInit, OnDestroy {
  versionNumber: any;
  quoteId: any;
  revisionAggregateData: any;
  subscription: Subscription = new Subscription();
  public router: Router;

  constructor(
    public _route: ActivatedRoute,
    private quoteRevisionInfoService: QuoteRevisionInfoService,
    public quoteRevisionService: QuoteRevisionService,
  ) {}

  ngOnInit(): void {
    this.quoteId = this.quoteRevisionInfoService.quoteId$;
    this.versionNumber = this.quoteRevisionInfoService.revertRevisionNumber$;

    const revisionAggregateSubscription = this.quoteRevisionService
      .getQuoteRevisionAggregate(+this.quoteId._value, +this.versionNumber._value)
      .subscribe(next => {
        this.revisionAggregateData = next;
      });
    this.subscription.add(revisionAggregateSubscription);
  }

  /// Hide revision rollback aside
  toggleRevertRevisionAside(): void {
    this.quoteRevisionInfoService._showRevertRevisionAside$.next(false);
  }

  refreshPageAfterRollback(): void {
    window.location.reload();
  }

  /// Call rollback endpoint with quote ID and version number to store a version
  rollbackRevision() {
    if (this.quoteId._value && this.versionNumber._value) {
      this.quoteRevisionService.rollbackRevision(+this.quoteId._value, +this.versionNumber._value);
    }
    this.quoteRevisionInfoService._showRevertRevisionAside$.next(false);
    this.refreshPageAfterRollback();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/revert-revision-aside/revert-revision-aside.component.ts